import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { AvailsResponse } from '../types/Avail';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface AvailsFilters {
  show_date?: string;
  start_date?: string;
  end_date?: string;
  gender?: string;
  can_host?: boolean;
  is_friend?: boolean;
  is_cellar_comic?: boolean;
}

export const getAvails = async (filters?: AvailsFilters): Promise<AvailsResponse> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString() || '';

    // Build query string
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }

    const queryString = params.toString();
    const url = `/avails${queryString ? `?${queryString}` : ''}`;

    const response = await api.get(url, {
      headers: {
        Authorization: token,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error('Error fetching avails:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch avails');
  }
};
